// import $ from "jquery";
import {Loader} from "@googlemaps/js-api-loader"

const mapStyle = require("./goole-map-style.js");

$(function () {
    const markers = $('span.gmap-marker');
    let map, location, list_location = [];
    let el = $("#g-map").get(0);

    const loader = new Loader({
        apiKey: "AIzaSyAVjxnANd6GRHzpoC2ZL7ps91sl_q6JIeA",
        version: "weekly",
    });

    loader.load().then(() => {
        const map = new google.maps.Map(el, {
            styles: mapStyle.jomonMapStyle
        });
        setMarkers(map)
    });

    function setMarkers(map) {
        let bounds = new google.maps.LatLngBounds();
        const infowindow = new google.maps.InfoWindow();
        for (let i = 0; i < list_location.length; i++) {
            let area = list_location[i];
            let marker = new google.maps.Marker({
                position: { lat: area.lat, lng: area.lng },
                map: map,
                icon: area.icon,
                animation: google.maps.Animation.DROP
            });

            bounds.extend(marker.position);
            
            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    infowindow.setContent(
                      `<div id="gmap-window"><h1>${area.title}</h1></div>`
                    );
                    infowindow.open(map, marker);
                }
            })(marker, i));
        }
        map.fitBounds(bounds);
    }

    const getLocation = (el) => {
        return {
            title: el.data('title'),
            lat: parseFloat(el.data('latlng').split(',')[0]),
            lng: parseFloat(el.data('latlng').split(',')[1]),
            icon: el.data('icon')
        };
    }

    if (markers.length) {
        markers.each(function () {
            location = getLocation($(this))
            list_location.push(location)
        });
    }
})

